export default {
  'app.pwa.offline': 'В данный момент не в сети',
  'app.pwa.serviceworker.updated': 'Новый контент',
  'app.pwa.serviceworker.updated.hint':
    'Пожалуйста, нажмите кнопку "Обновить" или обновите страницу вручную',
  'app.pwa.serviceworker.updated.ok': 'Обновить',
};
